import { render } from "./FormElementDescription.vue?vue&type=template&id=3a4cb736&ts=true"
import script from "./FormElementDescription.vue?vue&type=script&lang=ts"
export * from "./FormElementDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__